import { getTimelineEventList } from './timelineEvents';

/** Default: include cases whose activity window overlaps the filter (inclusive). */
export const ACTIVITY_DATE_MODE_DEFAULT = 'overlap';

/**
 * Prefer denormalized first/last activity from the API; fill from timeline events if missing.
 * @returns {{ fa: string|null, la: string|null }} YYYY-MM-DD
 */
export function getActivityWindowDates(app) {
  let fa = app.first_activity_date ? String(app.first_activity_date).slice(0, 10) : null;
  let la = app.last_activity_date ? String(app.last_activity_date).slice(0, 10) : null;
  if (fa && la) return { fa, la };

  const dates = getTimelineEventList(app.timeline)
    .map((e) => (e?.date ? String(e.date).slice(0, 10) : null))
    .filter(Boolean)
    .sort();

  if (dates.length === 0) return { fa, la };
  if (!fa) fa = dates[0];
  if (!la) la = dates[dates.length - 1];
  return { fa, la };
}

function timelineHasAnyEventInRange(app, df, dt) {
  for (const ev of getTimelineEventList(app.timeline)) {
    const ed = ev?.date ? String(ev.date).slice(0, 10) : '';
    if (ed && ed >= df && ed <= dt) return true;
  }
  return false;
}

/** @param {'first' | 'overlap' | 'last'} mode */
export function matchesActivityDateFilter(app, df, dt, mode) {
  const { fa, la } = getActivityWindowDates(app);
  const inRange = (d) => d != null && d !== '' && d >= df && d <= dt;

  if (mode === 'first') {
    return inRange(fa);
  }
  if (mode === 'last') {
    return inRange(la);
  }
  // overlap: activity interval [fa, la] intersects [df, dt], inclusive
  if (fa && la) {
    return la >= df && fa <= dt;
  }
  return timelineHasAnyEventInRange(app, df, dt);
}
